import { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import Button from "@components/core/Button";

function BackToTop() {
  const timer = useRef(null);
  const [displayBtn, setDisplayBtn] = useState(false);

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  function displayOrHideBtn() {
    if (timer.current) clearTimeout(timer.current);

    timer.current = setTimeout(() => {
      const { innerHeight, scrollY } = window;

      if (scrollY > innerHeight) {
        setDisplayBtn(true);
      } else {
        setDisplayBtn(false);
      }
    }, 150);
  }

  useEffect(() => {
    window.addEventListener("scroll", displayOrHideBtn);

    return () => window.removeEventListener("scroll", displayOrHideBtn);
  }, []);

  return (
    <div className={classNames("back-to-top-btn-container", displayBtn ? "d-flex" : "d-none")}>
      <Button
        variant="primary"
        rightIconName="arrow-up-lg"
        onClick={scrollToTop}
      />
    </div>
  );
}

export default BackToTop;
